import { useEffect, useState } from "react"


export const useDebouncedInput = (initialValue = "", delay=1000)=> {
    const [input, setInput] = useState(initialValue);
    const [debouncedInput, setDebouncedInput] = useState(initialValue);

    useEffect(()=> {
        const timer =setTimeout(()=> {

            setDebouncedInput(input);
        },delay )
        return () => clearTimeout(timer);
    },[input]);

    return({input, setInput, debouncedInput});
}